import createStyles from '@mui/styles/createStyles';

const styles = createStyles({
  alert: {
    width: '100%',
  },
});

export default styles;
